import { createRouter, createWebHistory } from 'vue-router'
import Home from '../components/cashComponent.vue'
import { getAppId } from '../util/appid.js'
/* eslint-disable */

// 修正：区分微信/支付宝AppId（替换为你的真实支付宝AppId）
const WXPAY_APP_ID = 'wx33818495adcf91e6'
const ALIPAY_APP_ID = '你的真实支付宝AppId' // 关键：替换为支付宝开放平台的AppId

const router = createRouter({
  history: createWebHistory(window.location.origin),
  routes: [{
    path: '/',
    name: 'Home',
    component: Home,
  }
  ],
})

router.beforeEach(async(to, from, next) => {
  const searchParams = new URLSearchParams(window.location.search)
  const code = searchParams.get('code')         // 微信授权码
  const authCode = searchParams.get('auth_code') // 支付宝授权码
  const state = searchParams.get('state')       // 平台标识（wechat/alipay）
  const cashPointId = searchParams.get('cp_id') // 现金点ID

  // 调用getAppId（建议加await，确保执行完成）
  await getAppId()

  // 调试用alert（生产环境可删除）
  alert('code: ' + code + '\nstate: ' + state)

  // 1. 已获取授权码：处理授权逻辑（避免重复授权）
  if (code && state === 'wechat') { // 微信授权回调
    try {
      const response = await fetch(`/stage-api/miniapp/logins/access_token`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          code,
          appid: WXPAY_APP_ID,
          platform: state
        }),
      })
      const data = await response.json()
      // 存储关键信息
      localStorage.setItem('appId', WXPAY_APP_ID)
      localStorage.setItem('uuid', data.uuid)
      localStorage.setItem('cashPointId', cashPointId || '')
      // 清除URL中的授权参数，避免重复处理
      window.history.replaceState({}, document.title, window.location.pathname)
      next()
    } catch (error) {
      console.error('微信授权失败:', error)
      next('/error')
    }
  } else if (authCode && state === 'alipay') { // 支付宝授权回调
    try {
      const response = await fetch(`/stage-api/miniapp/logins/access_token`, {
        // 统一用/stage-api/（匹配Nginx配置），避免/api/404
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          appid: ALIPAY_APP_ID,
          code: authCode,
          platform: state,
          cash_point_id: cashPointId
        }),
      })
      const data = await response.json()
      localStorage.setItem('appId', ALIPAY_APP_ID)
      localStorage.setItem('uuid', data.uuid)
      localStorage.setItem('cashPointId', cashPointId || '')
      window.history.replaceState({}, document.title, window.location.pathname)
      next()
    } catch (error) {
      console.error('支付宝授权失败:', error)
      next('/error')
    }
  } else {
    // 2. 未获取授权码：判断环境并跳转授权
    // 先存储cashPointId（如果有）
    if (cashPointId) {
      localStorage.setItem('cashPointId', cashPointId)
    } else {
      localStorage.setItem('cashPointId', '')
    }

    const userAgent = navigator.userAgent.toLowerCase()
    // 微信环境：跳转微信授权
    if (userAgent.match(/micromessenger/i)) {
      window.location.href = generateWechatAuthUrl(cashPointId)
    }
    // 支付宝环境：优先用JSBridge（体验更好），备用跳转链接
    else if (userAgent.match(/alipayclient/i)) {
      if (window.AlipayJSBridge) {
        handleAlipayAuth()
      } else {
        document.addEventListener('AlipayJSBridgeReady', handleAlipayAuth, false)
      }
    }
    // 非微信/支付宝环境
    else {
      alert('请在微信或支付宝中打开')
      next() // 继续导航到首页
    }
  }
})

// 生成微信授权链接（关键：编码redirectUri，携带cashPointId）
function generateWechatAuthUrl(cashPointId) {
  // 核心修复：对redirectUri进行URL编码
  const redirectUri = encodeURIComponent('https://staging.pay.xaszlt.com')
  const state = 'wechat'
  // 携带cashPointId到授权回调（可选，根据需求）
  let authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${WXPAY_APP_ID}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_base&state=${state}#wechat_redirect`
  if (cashPointId) {
    authUrl += `&cp_id=${cashPointId}`
  }
  return authUrl
}

// 生成支付宝授权链接（备用，优先用JSBridge）
function generateAlipayAuthUrl(cashPointId) {
  const redirectUri = encodeURIComponent(window.location.origin)
  const state = 'alipay'
  let authUrl = `https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=${ALIPAY_APP_ID}&redirect_uri=${redirectUri}&state=${state}&scope=auth_base`
  if (cashPointId) {
    authUrl += `&cp_id=${cashPointId}`
  }
  return authUrl
}

// 支付宝JSBridge授权（核心：获取authCode后手动跳转）
function handleAlipayAuth() {
  alert('正在获取支付宝授权...')
  window.ap.getAuthCode({
    appId: ALIPAY_APP_ID,
    scopes: ['auth_base'], // 静默授权，无需用户确认
    showErrorTip: true,
  }).then(res => {
    const authCode = res.authCode
    const cashPointId = localStorage.getItem('cashPointId')
    // 获取authCode后，拼接参数跳回本页面，触发路由守卫处理
    let redirectUrl = `${window.location.origin}?auth_code=${authCode}&state=alipay`
    if (cashPointId) {
      redirectUrl += `&cp_id=${cashPointId}`
    }
    window.location.href = redirectUrl
  }).catch(error => {
    alert('支付宝授权失败：' + JSON.stringify(error))
    console.error('支付宝授权错误:', error)
  })
}

export default router